<template>
<section class="termsBox">

    <h2 class="conTit1 mgt1">개인정보처리방침</h2>

    <div class="termsCon">
        <p>비엠더블유코리아㈜ (이하 BMW Korea ㈜로 표시함)는 BMW 고객님의 개인정보를 소중하게 생각하고, 고객님의 개인정보를 보호하기 위하여 최선을 다해 노력하고 있습니다.</p>
        <p>
            본 개인정보 처리방침은 BMW Korea ㈜가 제공하는 BMW Plus, MINI Plus 서비스 웹페이지(
            <a href="https://www.bmw-plus.co.kr" target="_blank" title="새창" class="linkTxt">https://www.bmw-plus.co.kr</a>, 
            <a href="https://www.mini-plus.co.kr" target="_blank" title="새창" class="linkTxt">https://www.mini-plus.co.kr</a> 
            이하 "BMW&MINI Plus 웹 홈페이지"라고 합니다)와 스마트폰 및 이동통신기기를 통해 제공되는 BMW Plus, MINI Plus 모바일 어플리케이션(이하 " BMW&MINI Plus 어플리케이션"라고 합니다) 및 BMW Plus, MINI Plus 모바일 인터넷 홈페이지(
            <a href="https://m.bmw-plus.co.kr" target="_blank" title="새창" class="linkTxt">https://m.bmw-plus.co.kr</a>, 
            <a href="https://m.mini-plus.co.kr" target="_blank" title="새창" class="linkTxt">https://m.mini-plus.co.kr</a> 
            이하 " BMW&MINI Plus 모바일 홈페이지"이라고 합니다)를 통해 제공하는 온라인 서비스 (이하 " BMW&MINI Plus 서비스" 라고 합니다)와 관련하여, 이 약관에 동의하고 서비스를 이용하는 회원 간의 권리와 의무, 책임사항 및 회원의 서비스 이용절차에 관한 사항 등을 규정함을 목적으로 합니다.
        <p>BBMW Korea ㈜는 개인정보보호 관련 주요 법률인 ‘개인정보 보호법’, ‘정보통신망 이용촉진 및 정보보호 등에 관한 법률’을 준수하기 위하여 개인정보처리방침을 제정하고 이를 준수하고 있으며, BMW&MINI Plus 서비스의 ‘개인정보처리방침’을 BMW&MINI Plus웹 홈페이지, BMW&MINI Plus 어플리케이션, BMW&MINI Plus 모바일 홈페이지에 공개하여 고객이 언제나 용이하게 열람할 수 있도록 하고 있습니다. BMW&MINI Plus의 ‘개인정보처리방침’은 관련 법률 및 지침의 변경 또는 내부 운영방침의 변경에 따라 변경될 수 있습니다. BMW Plus의 ‘개인정보처리방침’이 변경될 경우 변경된 ‘개인정보처리방침’을 BMW&MINI Plus 웹 홈페이지, BMW&MINI Plus 어플리케이션, BMW&MINI Plus 모바일 홈페이지를 통하여 공지합니다.</p>
        <p>BMW&MINI Plus의 개인정보처리방침은 다음과 같은 내용을 담고 있습니다.</p>
    </div>

    <div class="termsCon" id="termsPart1">

        <h2 class="termsTit">가. 개인정보 수집 및 이용 목적</h2>

        <ol class="circleNum">
            <li>① 회원 가입 및 관리
                <p>회원가입 의사확인, 본인 식별 및 인증, 회원자격 유지 및 관리, 서비스 부정이용 방지, 만 14세 미만 아동의 가입제한, 각종 고지 및 통지, 이용약관 위반 회원에 대한 이용제한 조치, 서비스의 원활한 운영에 지장을 미치는 행위 및 서비스 부정이용행위 제재, 가입 및 가입횟수 제한, 탈퇴의사 확인</p>
            </li>
            <li>② 서비스 제공
                <p>BMW&MINI Plus 웹 홈페이지, BMW&MINI Plus 어플리케이션, BMW&MINI Plus 모바일 홈페이지를 통한 정비 예약 서비스(공식 서비스 센터 예약)제공, 에어포트 서비스 예약, 위치기반의 가까운 지점 안내, 예약 확인 및 BMW&MINI Plus를 통해 예약 받은 서비스의 정비 내역, 캠페인 정보 및 차량 정보, BMW ServiceCare+ 정비 예약서비스(공식 서비스 센터 예약)제공, BMW ServiceCare+을 통해 예약 받은 서비스의 정비 내역 등</p>
            </li>
            <li>③ 서비스 개선
                <p>BMW&MINI Plus 웹 홈페이지, BMW&MINI Plus 어플리케이션, BMW&MINI Plus 모바일 홈페이지를 이용한 서비스를 회원의 컴퓨터 등 정보통신기기에 최적화된 방식으로 제공할 수 있도록 개선, 서비스 개발, 개선 등 BMW Korea ㈜의 업무와 관련된 통계자료의 작성</p>
            </li>
            <li>④ 마케팅 목적
                <p>마케팅 목적BMW Korea ㈜가 제공하는 서비스 캠페인 및 기타 혜택에 관련된 정보, 뉴스레터, 각종 이벤트 안내, 고객을 대상으로 실시하는 각종 마케팅 행사 등 정보 안내</p>
            </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart2">

        <h2 class="termsTit">나. 개인정보 수집 항목 및 수집 방법</h2>

        <p>BMW Korea ㈜는 수집한 개인정보를 다음의 목적을 위해 활용합니다. </p>

        <ol class="circleNum">
            <li>① 서비스 제공에 필요한 최소한의 필수 정보</li>
            <div class="termsTable">
                <table>
                    <caption>서비스 제공에 필요한 최소한의 필수 정보</caption>
                    <colgroup><col><col style="width:50%"></colgroup>
                    <thead>
                        <tr>
                            <th scope="col">목적</th>
                            <th scope="col">항목</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>BMW Plus 회원제 서비스 이용에 따른 본인확인, 회원가입</td>
                            <td>이름, 생년월일, 성별, 휴대전화번호, 전자우편주소, 비밀번호, 신용평가기관의 본인인증값(i-PIN, 휴대폰 인증값), 주소</td>
                        </tr>
                        <tr>
                            <td>BMW&MINI Plus를 통한 차량 서비스 예약/취소 정보 및 안내</td>
                            <td>이름, 이메일, 휴대전화번호, 차량정보(차대번호, 차량번호)</td>
                        </tr>
                        <tr>
                            <td>BMW ServiceCare+ 서비스 청약 및 제공을 위한 본인 확인, 서비스 청약에 따른 재화 거래 및 서비스 제공 의무 이행 및 서비스 개선, 불만/분쟁 처리 및 불법/부정이용 방지 등</td>
                            <td>Device ID, 차량정보(차대번호, 차량번호), 주소, 서비스 이용 내역, 불만 및 분쟁처리 내역</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <li>② 정보주체의 동의 하에 수집되는 선택 정보</li>
            <div class="termsTable">
                <table>
                    <caption>정보주체의 동의 하에 수집되는 선택 정보</caption>
                    <colgroup><col><col style="width:50%"></colgroup>
                    <thead>
                        <tr>
                            <th scope="col">목적</th>
                            <th scope="col">항목</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>서비스 개발, 개선 등 BMW Korea의 업무와 관련된 통계자료의 작성</td>
                            <td>이름, 생년월일, 성별, 주소, 차량정보(차대번호, 차량번호)</td>
                        </tr>
                        <tr>
                            <td>BMW&MINI Plus 캠페인 정보 및 각종 혜택 안내</td>
                            <td>이름, 이메일, 휴대전화번호, 차량번호(차대번호, 차량번호)</td>
                        </tr>
                        <tr>
                            <td>웹사이트 콘텐츠를 이용자의 컴퓨터 등 정보통신기기에 최적화된 방식으로 제공할 수 있도록 개선</td>
                            <td>Cookie</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </ol>
    </div>

    
    <div class="termsCon" id="termsPart3">
    
        <h2 class="termsTit">다. 개인정보 제3자 제공</h2>

        <p>BMW Korea ㈜는 고객님의 동의가 있거나 관련 법령의 규정에 의한 경우를 제외하고는 어떠한 경우에도 "가. 개인정보 수집 및 이용목적", "나. 개인정보 수집 항목 및 수집 방법"에서 고지한 범위를 넘어 고객님의 개인정보를 이용하거나 제3자에게 제공하지 않습니다. 서비스 별 개인정보 제공 및 이벤트에 따른 개인정보 제공의 경우 수시로 발생하는 서비스 제휴와 이벤트 진행으로 인해 개인정보처리방침 개정에 어려움이 있으며, 제공 내역은 다음과 같습니다.</p>
    
        <div class="termsTable">
            <table>
                <caption>개인정보 제3자 제공 정보</caption>
                <colgroup>
                    <col style="width:25%">
                    <col style="width:75%">
                </colgroup>
                <tbody>
                    <tr>
                        <th>제공받는 자</th>
                        <td>코오롱모터스㈜, ㈜한독모터스, 도이치모터스㈜, ㈜바바리안 모터스, ㈜동성모터스, ㈜삼천리 모터스, ㈜내쇼날 모터스</td>
                    </tr>
                    <tr>
                        <th>제공 목적</th>
                        <td>온라인 서비스 센터 예약을 위한 예약정보 제공, 서비스 예약관련 고객문의 응대 및 불만 처리, 예약 데이터 관리 및 통계 자료 작성</td>
                    </tr>
                    <tr>
                        <th>제공 항목</th>
                        <td>이름, 휴대전화번호, 보유차량 차대번호, 보유차량 차량번호, 주소</td>
                    </tr>
                    <tr>
                        <th>보유 및 이용 기간</th>
                        <td>개인정보 제3자 제공에 동의한 이용목적 달성 시까지. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 법령에서 규정한 일정한 기간동안 회원의 개인정보를 보관함. 또한 회원의 삭제 요청 혹은 BMW ServiceCare+ 해지, BMW&MINI Plus 탈퇴 시, 지체 없이 삭제함.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="termsTable">
            <table>
                <caption>개인정보 제3자 제공 정보</caption>
                <colgroup>
                    <col style="width:25%">
                    <col style="width:75%">
                </colgroup>
                <tbody>
                    <tr>
                        <th>제공받는 자</th>
                        <td>㈜바바리안 모터스</td>
                    </tr>
                    <tr>
                        <th>제공 목적</th>
                        <td>에어포트 서비스 예약을 위한 예약정보 제공, 서비스 예약관련 고객문의 응대 및 불만 처리, 예약 데이터 관리 및 통계 자료 작성</td>
                    </tr>
                    <tr>
                        <th>제공 항목</th>
                        <td>이이름, 휴대전화번호, 이메일, 보유차량 차대번호, 보유차량 차량번호, 주소</td>
                    </tr>
                    <tr>
                        <th>보유 및 이용 기간</th>
                        <td>개인정보 제3자 제공에 동의한 이용목적 달성 시까지. 단, 관계법령의 규정에 의하여 보존할 필요가 있는 경우 법령에서 규정한 일정한 기간동안 회원의 개인정보를 보관함. 또한 회원의 삭제 요청 혹은 BMW ServiceCare+ 해지, BMW&MINI Plus 탈퇴 시, 지체 없이 삭제함.</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="termsTable">
            <table>
                <caption>개인정보 제3자 제공 정보</caption>
                <colgroup>
                    <col style="width:25%">
                    <col style="width:75%">
                </colgroup>
                <tbody>
                    <tr>
                        <th>제공받는 자</th>
                        <td>비엠더블유인슈어런스서비스코리아㈜, 한화손해보험㈜</td>
                    </tr>
                    <tr>
                        <th>제공 목적</th>
                        <td>보험 서비스 청약 및 제공을 위한 본인 확인, 보험 서비스 청약에 따른 의무 이행, 분쟁 처리 및 불법/부정이용 방지 등</td>
                    </tr>
                    <tr>
                        <th>제공 항목</th>
                        <td>이름, 휴대전화번호, 보유차량 차대번호, 보유차량 차량번호, 주소</td>
                    </tr>
                    <tr>
                        <th>보유 및 이용 기간</th>
                        <td>이름, 휴대전화번호, 전자우편주소, 주소, 차대번호, 차량번호, 정비 이력</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="termsCon" id="termsPart4">

        <h2 class="termsTit">라. 개인정보 처리 위탁</h2>
        
        <p>BMW Korea ㈜는 원활한 개인정보 처리 업무를 위해 반드시 필요한 업무 중 일부를 외부 업체로 하여금 수행하도록 개인정보를 위탁하고 있으며, 위탁 받은 업체가 개인정보보호 관계 법령을 위반하지 않도록 관리·감독하고 있습니다. 위탁한 업무 및 위탁 받은 업체 다음과 같습니다.</p>
        
        <div class="termsTable">
            <table>
                <caption>개인정보 처리 위탁 정보</caption>
                <colgroup><col style="width:50%"><col style="width:50%"></colgroup>
                <thead>
                    <tr>
                        <th scope="col">위탁 업무</th>
                        <th scope="col">수탁 업체</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>BMW&MINI Plus, BMW ServiceCare+ 시스템 운영/유지보수 및 개인정보 저장 서버의 관리 업무</td>
                        <td>㈜에피카</td>
                    </tr>
                    <tr>
                        <td>BMW&MINI Plus 개인정보의 백업관리 및 유지</td>
                        <td>㈜에스이파트너즈</td>
                    </tr>
                    <tr>
                        <td>BMW&MINI Plus 콜센터 업무(서비스 및 예약 관련 고객 문의 응대) 대행</td>
                        <td>비엠더블유파이낸셜서비스코리아㈜</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="termsCon" id="termsPart5">

        <h2 class="termsTit">마. 개인정보의 국외이전</h2>

        <p>BMW Korea ㈜는 고객님께 아래에 기재된 서비스의 제공을 위하여 국외 업체에 업무를 위탁하고 있으며 이 과정에서 고객님의 개인정보가 국외로 이전됩니다. BMW Korea ㈜는 국외로 이전되는 귀하의 개인정보가 대한민국 법령과 BMW Korea ㈜를 비롯한 BMW Group의 내부 정책에 따라 안전하게 보호되도록 필요한 최선의 조치를 다하고 있습니다. 고객님께서는 개인정보의 국외 이전에 대해 동의를 거부하실 수 있으나, 그러한 경우 서비스 이용이 제한될 수 있음을 알려드립니다.</p>
        
        <div class="termsTable">
            <table>
                <caption>개인정보의 국외이전 목적/대상 및 이용 기간</caption>                    
                <colgroup>
                    <col style="width:30%">
                    <col style="width:70%">
                </colgroup>
                <tbody>
                    <tr>
                        <th scope="col">개인정보를 이전받는 자 및 연락처</th>
                        <td>Keyloop (UK) Limited(dpo@keyloop.com)</td>
                    </tr>
                    <tr>
                        <th scope="col">이전받는자의 개인정보 이용목적</th>
                        <td>서비스 센터 예약을 위한 IT 지원</td>
                    </tr>
                    <tr>
                        <th scope="col">이전하는 개인정보 항목</th>
                        <td>이름, 휴대전화번호, 보유차량 정보 (차대번호, 차량번호)</td>
                    </tr>
                    <tr>
                        <th scope="col">이전되는 국가, 이전 일시 및 이전 방법</th>
                        <td>싱가포르, 차대번호 입력 시, 암호화 보안 프로토콜(SSL) 처리된 인터넷 망을 이용한 전송 또는 전용망(VPN)을 이용한 전송</td>
                    </tr>
                    <tr>
                        <th scope="col">개인정보 보유 및 이용 기간</th>
                        <td>BMW&MINI Plus 회원을 탈퇴할 때까지 보유(관련 법률 및 규정에 의해 개인정보를 보유해야 하는 경우 제외)</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="termsCon" id="termsPart6">

        <h2 class="termsTit">바. 개인정보 보유 및 이용 기간</h2>

        <p>BMW Korea ㈜는 보유기간의 경과, 개인정보 수집 및 이용목적 달성 등 그 개인정보가 불필요하게 되었을 때에는 지체 없이 그 개인정보를 파기하는 것을 원칙으로 합니다. 단, 관련 법령의 규정에 의해 보존할 의무가 있는 경우 해당 법령에 근거하여 개인정보를 보관하며, BMW Korea ㈜는 해당 개인정보를 그 보관의 목적으로만 이용합니다.</p>
                
        <ol class="circleNum">
            <li>- 통신비밀보호법
                <ol class="numList">
                    <li>로그기록자료, 접속지의 추적자료 등 통신사실확인자료 : 3개월</li>
                </ol>
            </li>
            <li>- 전자상거래 등에서의 소비자보호에 관한 법률
                <ol class="numList">
                    <li>계약 또는 청약철회 등에 관한 기록 : 5년 보관</li>
                    <li>대금결제 및 재화 등에 공급에 관한 기록 : 5년 보관</li>
                    <li>소비자의 불만 또는 분쟁처리에 관한 기록 : 3년 보관</li>
                </ol>
            </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart7">

        <h2 class="termsTit">사. 개인정보 파기 절차 및 방법</h2>

        <p>BMW Korea ㈜는 개인정보 수집 및 이용 목적이 달성되거나 보유기간이 경과한 후에는 해당 정보를 지체 없이 파기하는 것을 원칙으로 합니다. 단, 관련 법령 및 내부 규정에 따라 보존할 필요가 있는 개인정보의 경우 수집 및 이용 목적이 달성된 후에 별도의 저장 공간으로 옮겨지며, 각각의 보존 근거 및 기간에 따라 보관 및 파기합니다. 이때 별도로 보관되는 개인정보는 각각의 보존 근거에 해당하는 목적 이외의 다른 목적으로 이용되지 않습니다. 개인정보를 파기할 때, 종이에 출력된 개인정보는 분쇄하거나 소각하여 파기하며, 전자적 파일 형태로 저장된 개인정보는 복구 및 재생되지 않도록 기술적인 방법을 이용하여 완전하게 삭제합니다.</p>
    
    </div>

    <div class="termsCon" id="termsPart8">

        <h2 class="termsTit">아. 개인정보 안전성 확보 조치</h2>

        <p>BMW Korea ㈜는 고객님의 개인정보를 처리함에 있어 분실, 도난, 유출, 변조 또는 훼손되지 않도록 안전성을 확보하기 위하여 다음과 같은 조치를 취하고 있습니다.</p>
        
        <ol class="circleNum">
            <li>① 관리적 조치
                <ol class="numList">
                    <li>- 개인정보보호를 위한 내부관리계획을 수립 및 운영하고 있으며, 임원진의 승인을 통해 전사 임직원을 대상으로 공유하고 있습니다.</li>
                    <li>- 개인정보보호 역할 및 책임을 갖는 책임자, 관리자, 담당자 등 인력을 지정하고, 개인정보보호 위원회를 구성하였습니다. 정기적인 개인정보보호 위원회 회의 등을 통하여 개인정보보호 이슈 등의 사항에 대해 개선하기 위한 노력을 기울이고 있습니다.</li>
                    <li>- 모든 개인정보 처리자를 대상으로 개인정보보호 서약서를 징수하고, 연 2회 이상의 개인정보보호 교육을 수행하여 안전한 개인정보 처리 방법을 전파하고 있습니다.</li>
                    <li>- 제3자 제공 업체 및 수탁 업체가 개인정보를 안전하게 처리하도록 관리·감독하고 있으며, 해당 업체들을 포함하는 개인정보보호 감사를 정기적으로 실시하고 있습니다.</li>
                </ol>
            </li>
            <li>② 기술적 조치
                <ol class="numList">
                    <li>- 개인정보 처리자들이 불필요한 개인정보에 접근 혹은 노출되지 않도록 통제하여, 업무 상 최소한의 계정 및 권한을 가지도록 관리하고 있습니다.</li>
                    <li>- 고객님의 개인정보를 시스템(DB)이나 PC에 저장하는 경우에는 강력한 알고리즘으로 암호화하여 외부 침입에 의해 유출되더라도 해당 정보를 활용할 수 없도록 하고 있습니다. 시스템 간 개인정보가 전송되는 경우에도 마찬가지로 안전하게 암호화하여 처리하고 있습니다.</li>
                    <li>- 개인정보를 처리하는 시스템 및 PC를 보호하기 위해서 다양한 인프라 및 솔루션을 구축하여 운영 중이며, 내부 및 외부로부터 발생할 수 있는 사고를 방지하기 위하여 계속적으로 모니터링을 수행하고 있습니다.</li>
                </ol>
            </li>
            <li>③ 물리적 조치
                <ol class="numList">
                    <li>- 전산실, 사무실 등의 공간에 대해서 출입을 엄격히 통제하고 있습니다.</li>
                    <li>- 문서고, 자료보관실과 같이 개인정보가 보관되고 있는 곳은 추가적인 잠금 장치를 이용하고 있습니다.</li>
                </ol>
            </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart9">

        <h2 class="termsTit">자. 고객 및 법정대리인의 권리와 행사방법</h2>

        <p>고객님 또는 법정대리인은 관련 법령에 따라 제한되지 않는 한 언제든지 등록되어 있는 자신의 개인정보를 조회하거나 수정할 수 있으며, 개인정보 수집, 이용, 제공 등의 동의를 철회(가입해지) 할 수 있습니다.</p>
        <p>고객님의 개인정보 조회, 수정, 동의철회를 위해서는, BMW 커뮤니케이션 센터 (Tel. 080-700-8000) / MINI 커뮤니케이션 센터 (Tel. 080-700-8000) 으로 연락하시거나, 개인정보보호책임자에게 서면, 전화 또는 이메일로 연락하시면 요청하신 내용을 조치하겠습니다.</p>
        <p>개인정보의 오류에 대한 정정을 요구하신 경우에는 정정을 완료하기 전까지 당해 개인정보를 이용 또는 제공하지 않습니다. 또한 잘못된 개인정보를 제3자에게 이미 제공한 경우에는 정정 처리결과를 제3자에게 통지하여 정정이 이루어지도록 하겠습니다.</p>

    </div>

    <div class="termsCon" id="termsPart10">
        
        <h2 class="termsTit">차. 개인정보 자동수집 장치의 설치, 운영 및 거부에 관한 사항</h2>
        
        <p>BMW Korea ㈜는 개인화되고 맞춤화된 서비스를 제공하기 위해서, 고객님의 정보를 저장하고 수시로 불러오는 '쿠키(cookie)'를 사용합니다.</p>
        <p>쿠키는 웹 사이트를 운영하는데 이용되는 서버가 고객님의 브라우저에게 보내는 아주 작은 텍스트 파일로 고객님 컴퓨터의 하드 디스크에 저장됩니다. 이후 고객님이 웹 사이트에 방문하실 경우 웹 사이트 서버는 고객님의 하드 디스크에 저장되어 있는 쿠키의 내용을 읽어 고객님의 환경설정을 유지하고 맞춤화된 서비스를 제공하는데 이용합니다. 쿠키는 개인을 식별하는 정보를 자동적/능동적으로 수집하지 않으며, 고객님은 언제든지 이러한 쿠키의 저장을 거부하거나 삭제할 수 있습니다.</p>
        
        <ol class="circleNum">
            <li>① 사용 목적
                <ol class="numList">
                    <li>o BMW Korea ㈜는 회원과 비회원의 접속빈도나 방문시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공을 위하여 쿠키를 사용하고 있습니다.</li>
                </ol>
            </li>
            <li>② 거부 방법
                <ol class="numList">
                    <li>o&nbsp;&nbsp;고객님은 쿠키 설치에 대한 선택권을 가지고 있습니다. 따라서 고객님은 모든 쿠키를 허용하거나, 쿠키가 저장될 때마다 확인을 거치거나, 아니면 모든 쿠키의 저장을 거부할 수도 있습니다.</li>
                    <li>o  단, 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다</li>
                    <li>o  쿠키 설치 허용 여부를 지정하는 방법은 다음과 같습니다. (Internet Explorer의 경우)
                        <ol class="numList">
                            <li>1. [도구] 메뉴에서 [인터넷 옵션]을 선택합니다.</li>
                            <li>2. [개인정보 탭]을 클릭합니다.</li>
                            <li>3. [개인정보처리 수준]을 설정하시면 됩니다.</li>
                        </ol>
                    </li>
                </ol>
            </li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart11">

        <h2 class="termsTit">카. 개인정보보호 책임자 및 담당자</h2>

        <p>BMW Korea ㈜는 고객님의 개인정보를 보호하고 불만 처리 및 피해 구제 등을 위해 다음과 같이 책임자 및 담당자를 지정하여 운영하고 있습니다. 언제라도 문의 주시면 신속하고 충분한 답변을 드리도록 하겠습니다.</p>
        
        <ol class="circleNum">
            <li>① 개인정보보호 책임자
                <ul class="dotList">
                    <li>o 이름 또는 부서: Sales Channel Development 총괄 주양예 전무</li>
                    <li>o 전화번호: 080-700-8000</li>
                    <li>o 이메일: bmw@bmw.co.kr</li>
                </ul>
            </li>
            <li>② 개인정보보호 담당자
                <ul class="dotList">
                    <li>o 이름 또는 부서: Compliance 김승욱 매니저</li>
                    <li>o 전화번호: 080-700-8000</li>
                    <li>o 이메일: bmw@bmw.co.kr</li>
                </ul>
            </li>
        </ol>

        <p>기타 개인정보침해에 대한 신고나 상담이 필요하신 경우에는 아래 기관에 문의하시기 바랍니다.</p>

        <ol class="circleNum">
            <li>① 개인정보침해신고센터 : (국번없이) 118 (<a href="http://privacy.kisa.or.kr/" target="_blank" title="새창" class="linkTxt">privacy.kisa.or.kr/</a>)</li>
            <li>② 대검찰청 사이버범죄수사단 : 02-3480-3571 (<a href="http://www.spo.go.kr/" target="_blank" title="새창" class="linkTxt">http://www.spo.go.kr/</a>)</li>
            <li>③ 경찰청 사이버안전국 : (국번없이) 182 (<a href="http://cyberbureau.police.go.kr" target="_blank" title="새창" class="linkTxt">http://cyberbureau.police.go.kr</a>)</li>
        </ol>
    </div>

    <div class="termsCon" id="termsPart12">

        <h2 class="termsTit">타. 링크사이트</h2>

        <p>BMW Korea㈜는 고객님에게 다른 회사의 웹사이트 또는 자료에 대한 링크를 제공할 수 있습니다. 이 경우 BMW Korea㈜는 외부사이트 및 자료에 대한 아무런 통제권이 없으므로 그로부터 제공 받는 서비스나 자료의 유용성에 대해 책임을 부담하기 어려우며 보증할 수 없습니다.</p>
        
        <p>BMW Korea ㈜가 포함하고 있는 링크를 클릭하여 타 웹사이트의 페이지로 옮겨갈 경우 해당 웹사이트의 개인정보보호 정책은 BMW Korea ㈜와 무관하므로 새로 방문한 웹사이트의 정책을 확인해 주시기 바랍니다.</p>
    
    </div>

    <div class="termsCon" id="termsPart13">

        <h2 class="termsTit">파. 내용변경의 고지</h2>

        <p>
            위 내용에 대한 추가, 삭제 및 수정이 있을 경우에는 시행하는 날로부터 최소 7일 전에 공지사항 등을 통해 이용자에게 설명 드리겠습니다. 다만 이용자의 소중한 권리 또는 의무에 중요한 내용 변경은 최소 30일 전에 알려 드리겠습니다.
            <br>
            본 방침은 2022년 3월 31일부터 시행됩니다.
        </p>
    
    </div>
    
</section>
</template>

<script>
export default {
    name: 'TermPersonalInfo'
}
</script>

<style lang="scss" scoped>
</style>